import { makeStyles } from 'tss-react/mui';

export const useMessageNotificationSnackbarStyles = makeStyles()((theme) => ({
  wrapper: {
    position: 'relative',
    alignSelf: 'center',
    boxSizing: 'border-box',
    height: '28px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '14px',
    textAlign: 'center',
    color: 'white',
    padding: '4px 16px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '-6px',
      bottom: '5px',
      width: '12px',
      height: '12px',
      backgroundRepeat: 'no-repeat',
      background: `url('data:image/svg+xml,<svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.465055 8.8693C0.448229 8.85301 0.453791 8.82467 0.475299 8.8154V8.8154C3.81118 7.37789 6.33867 4.45399 7.23729 0.934468L7.36057 0.451618L9.60622 12.5234L7.80149 12.3228C5.041 12.016 2.46052 10.8013 0.465055 8.8693V8.8693Z" fill="%23FF703D"/></svg>')`,
    },
  },
  text: {
    fontWeight: 600,
    maxWidth: '230px',
    overflowX: 'hidden',
  },
}));
